import { combineReducers } from "redux";
import apiReducer from "./apiCalls";
import authReducer from "./authReducer";
import branchReducer from "./branchReducer";
import branchManagerReducer from "./branchManagerReducer";
import branchOfficerReducer from "./branchOfficerReducer";
import reviewerReducer from "./reviewerReducer";
import applicationReducer from "./applicationReducer";
import agentReducer from "./agentReducer";
import agentUserReducer from "./agentUserReducer";

// Combine all reducers as root reducer
export default combineReducers({
  authReducer,
  apiReducer,
  branchReducer,
  branchManagerReducer,
  branchOfficerReducer,
  reviewerReducer,
  applicationReducer,
  agentReducer,
  agentUserReducer,
});
